import React from "react";
import { motion } from "framer-motion";
import { Map, Users, FileCheck, Star, ShieldCheck, Plane } from "lucide-react";

const outcomes = [
  { icon: Map, text: "Clear roadmap with timelines and accountability" },
  { icon: Users, text: "Stronger profile and positioning before applications" },
  { icon: FileCheck, text: "Shortlist with realistic conversion chances" },
  { icon: Star, text: "Higher quality applications — coherent and compelling" },
  { icon: ShieldCheck, text: "Visa readiness and reduced documentation stress" },
  { icon: Plane, text: "Pre-departure confidence and a clear start abroad" },
];

export default function Outcomes() {
  return (
    <section
      id="outcomes"
      data-testid="outcomes-section"
      style={{ padding: "100px 0", backgroundColor: "#fff" }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 24px" }}>
        <div style={{ gap: "80px" }} className="mw-grid-2">

          {/* Left */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.15em", textTransform: "uppercase", color: "#F5A000", fontFamily: "'DM Sans', sans-serif" }}>
              What You Gain
            </span>
            <h2 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "clamp(28px, 4vw, 44px)",
              fontWeight: "700",
              color: "#0F172A",
              margin: "16px 0 24px",
              lineHeight: "1.2",
            }}>
              What you get by working with us
            </h2>
            <p style={{ fontSize: "17px", color: "#64748B", fontFamily: "'DM Sans', sans-serif", lineHeight: "1.7", maxWidth: "400px" }}>
              Not just an admission — a structured, well-executed journey from where you are to where you want to be.
            </p>
          </motion.div>

          {/* Right: outcomes grid */}
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={{ show: { transition: { staggerChildren: 0.1 } } }}
            className="mw-grid-4"
            style={{ gap: "16px" }}
          >
            {outcomes.map((o, i) => {
              const Icon = o.icon;
              return (
                <motion.div
                  key={o.text}
                  variants={{ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0 } }}
                  data-testid={`outcome-item-${i}`}
                  style={{
                    backgroundColor: "#F8FAFC",
                    borderRadius: "12px",
                    padding: "24px 20px",
                    border: "1px solid #E2E8F0",
                    transition: "all 0.2s",
                  }}
                  whileHover={{ borderColor: "#2B2F9E", backgroundColor: "#EEF0FC" }}
                >
                  <Icon size={24} style={{ color: "#2B2F9E", marginBottom: "12px" }} />
                  <p style={{ fontSize: "14px", fontWeight: "600", color: "#0F172A", fontFamily: "'DM Sans', sans-serif", margin: 0, lineHeight: "1.5" }}>
                    {o.text}
                  </p>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
